import type { TPersistentStoreName } from '../persistenceStoresCleanUpMap'

export const setSearchParams = (
  storeName: TPersistentStoreName,
  searchParams: { [key: string]: unknown },
) => {
  const url = new URL(window.location.href)

  if (Object.keys(searchParams).length) {
    url.searchParams.set(storeName, JSON.stringify(searchParams))

    history.pushState(null, '', url)
  }
}
